import './Footer.css'

const Footer = () => {
  const scrollToSection = (href: string) => {
    const target = document.querySelector(href)
    if (target) {
      const offsetTop = (target as HTMLElement).offsetTop - 80
      window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="brand-lockup brand-lockup--footer">
              <img src="/logo-mark.svg" alt="" className="brand-mark" />
              <span className="brand-word">
                <span className="brand-name">ECHO</span>
                <span className="brand-tag">Your Voice Lives</span>
              </span>
            </span>
            <p>Helping people prepare today so the people they love and serve will not have to struggle tomorrow.</p>
            <p className="footer-company">L3 – Live. Love. Legacy LLC</p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4>Explore</h4>
              <ul>
                <li>
                  <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('#about') }}>
                    About
                  </a>
                </li>
                <li>
                  <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('#how-it-works') }}>
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('#services') }}>
                    Services
                  </a>
                </li>
                <li>
                  <a href="#legacy-books" onClick={(e) => { e.preventDefault(); scrollToSection('#legacy-books') }}>
                    Journals
                  </a>
                </li>
                <li>
                  <a href="#stories" onClick={(e) => { e.preventDefault(); scrollToSection('#stories') }}>
                    Stories
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>Connect</h4>
              <ul>
                <li>
                  <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('#contact') }}>
                    Contact
                  </a>
                </li>
                <li>
                  <a href="mailto:hello@echocares.info">hello@echocares.info</a>
                </li>
                <li>
                  <a href="tel:+13364376147">(336) 437-6147</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 L3 – Live, Love, Legacy LLC Holding Company. Your Voice Lives.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
